import { createI18nText } from "@hilma/netina2all"

const stationManagementText = createI18nText({
    he: {
        title: 'פרטי התחנה',
        approvalPending: <><span>פרטי התחנה נשלחו לאישור,</span><br /><span>נעדכן אותך כאשר תקבל אישור</span></>,
        saveOptions: {
            dontSend: 'שמור מבלי לשלוח',
            send: 'שמור ושלח',
        },
        address: {
            title: 'כתובת',
            typeOrClick: "אנא הקלד כתובת מדוייקת (כולל מס' בית) או סמן אותה על המפה",
            acPlaceholder: 'חיפוש',
            addressNotAccurate: <span>הכתובת המוצעת אינה תואמת למיקום שנבחר,<br />אנא נסו להקליד את הכתובת בתיבת החיפוש</span>,
            stationName: 'שם התחנה',
            stationNumber: 'מספר תחנה',
            arrivalInstructions: 'הוראות הגעה מיוחדות',
            tooltip: 'הסבירו בבירור כיצד להגיע אליכם',
            aiPlaceholder: 'דירה, כניסה...',
            area: 'אזור',
            city: 'עיר',
            street: 'רחוב',
        },
        openingHours: {
            title: 'זמני פעילות',
            noDaysMessage: 'טרם נקבעו ימי החלוקה',
            addHours: 'הוסף טווח שעות',
            allDay: 'כל היום (08:00 - 22:00)',
            allDayFriday: 'כל היום (08:00 - 16:00)',
            allDaySaturday: 'כל היום (20:00 - 23:00)',
            isClosed: 'התחנה סגורה',
            customized: 'בחירה אישית',
            byAppointment: 'בתיאום מראש',
            allClosedError: 'התחנה חייבת להיות פתוחה לפחות יום אחד',
            save: 'שמור',
            close: 'תחנה סגורה',
            tooltip: 'התחנה חייבת לפעול לפחות ביום אחד מימי החלוקה',
        },
        deliveryOpeningHours: {
            title: 'זמני משלוח',
            noDaysMessage: 'טרם נקבעו ימי המשלוח',
            tooltip: 'התחנה חייבת להיות זמינה לפחות ביום אחד מימי המשלוח',
        },
        managerDetails: {
            title: 'פרטי מנהל',
            fullName: 'שם מלא - מנהל',
            email: 'מייל',
            phone: 'טלפון נייד',
            additionalPhone: 'טלפון נייד נוסף',
        },
        areaManagerDetails: {
            title: 'פרטי אחראי אזור',
            fullName: 'שם מלא - אחראי',
            email: 'מייל',
            phone: 'טלפון נייד',
        },
        additionalDetails: {
            title: 'פרטים נוספים',
            maxKits: 'מקסימום מוצרים',
            tooltipMaxKits: 'המספר המקסימלי של מוצרים שתוכלו לאחסן. מעבר למספר זה לא ירשמו דרככם אנשים לחלוקה.',
            noLimitKits: 'ללא הגבלה',
            goalKits: 'יעד מוצרים (למעוניינים)',
            tooltipGoalKits: 'קבעו מספר מוצרים שאליו תשאפו להגיע בתום תקופת הרכישה. יעד זה אינו מחייב.',
            lastYearSold: 'שנה שעברה מספר המוצרים שמכרתם היה',
            image: {
                title: 'תמונה',
                label: 'לצורך הקלה על איתור ביתכם, ניתן לצרף תמונה:',
                upload: 'העלה קובץ',
                tooltip: 'צלמו את ביתכם מבחוץ כך שניתן יהיה לזהותו',
            },
            accessible: 'נגישה לנכים',
            yes: ' כן',
            no: 'לא',
            link: 'קישור ייעודי לרכישה',
            linkTooltip: 'קישור זה מאפשר רכישה אוטומטית מתחנה זו',
            copyLink: 'העתק קישור',
            purchased: 'מוצרים שנרכשו בתחנה זו',
            maxKitsNote: '*שים לב - מקסימום מוצרים חייב להיות גדול מכמות המוצרים שכבר נרכשה',
        }
    },
    en: {
        title: 'Station Details',
        approvalPending: <><span>The station details were sent for approval,</span><br /><span>we will update you when they are approved</span></>,
        saveOptions: {
            dontSend: 'Save without sending',
            send: 'Save and send'
        },
        address: {
            title: 'Address',
            typeOrClick: 'Please type in an exact address (including house number) or mark it on the map',
            acPlaceholder: 'Search',
            addressNotAccurate: <span>The suggested address doesn't match the chosen location,<br />please try to type the address in the search box</span>,
            stationName: 'Station Name',
            stationNumber: 'Station Number',
            arrivalInstructions: 'Arrival Instructions',
            tooltip: 'Explain clearly how to reach you',
            aiPlaceholder: 'Appartment, entrance, etc.',
            area: 'Area',
            city: 'City',
            street: 'Street',
        },
        openingHours: {
            title: 'Opening Hours',
            noDaysMessage: 'Pickup days have not been set yet',
            addHours: 'Add a Time Span',
            allDay: 'All Day (08:00 AM - 10:00 PM)',
            allDayFriday: 'All Day (08:00 AM - 16:00 PM)',
            allDaySaturday: 'All Day (20:00 PM - 23:00 PM)',
            isClosed: 'Close',
            customized: 'Customized',
            byAppointment: 'By Appointment',
            allClosedError: 'The station must be open on at least one day',
            save: 'save',
            close: 'closed station',
            tooltip: 'The station must be open for at least one day',
        },
        deliveryOpeningHours: {
            title: 'Delivery Hours',
            noDaysMessage: 'Delivery days have not been set yet',
            tooltip: 'The station must available on at least one day',
        },
        managerDetails: {
            title: 'Station Manager Details',
            fullName: 'Manager Full Name',
            email: 'Email',
            phone: 'Phone',
            additionalPhone: 'Additional Phone',
        },
        areaManagerDetails: {
            title: 'Area Manager Details',
            fullName: 'Manager Full Name',
            email: 'Email',
            phone: 'Phone',
        },
        additionalDetails: {
            title: 'Additional Details',
            noLimitKits: 'No Limit',
            maxKits: 'Maximum Products',
            tooltipMaxKits: 'The maximum number of products you will be able to store. Products will not be registered to your station beyond this number.',
            goalKits: 'Goal Number of Products (for those interested)',
            tooltipGoalKits: 'Set the number of products you hope to reach at the end of the purchase period. This number is not binding.',
            lastYearSold: 'Last year the number of products you sold was',
            image: {
                title: 'Image',
                label: 'It is recommended to add an image to help the customers find your house:',
                upload: 'upload image',
                tooltip: 'Photograph your home from the outside so that it can be identified',
            },
            accessible: 'Accessible',
            yes: 'Yes',
            no: 'No',
            link: 'Direct link to purchase',
            linkTooltip: 'This link enables purchasing automatically from this station.',
            copyLink: 'copy link',
            purchased: 'Purchased products in this station',
            maxKitsNote: '*Attention - maximum products must be greater than the amount of the purchased products',
        }
    }
})

export default stationManagementText